<template>
  <span
    class="inline-block"
    :class="`text-${color}`"
  >
    <component
      :is="icon"
      :width="size"
      :height="size"
      :color="color"
      class="mb-px"
      aria-hidden="true"
      focusable="false"
    />
  </span>
</template>

<script>
import iconvideo from '@/components/icons/IconVideo.vue'
import icongallery from '@/components/icons/IconGallery.vue'
import iconpost from '@/components/icons/IconPost.vue'
import iconlinkout from '@/components/icons/IconLinkout.vue'
import iconmappin from '@/components/icons/IconMapPin.vue'
import iconprospectus from '@/components/icons/IconProspectus.vue'
import iconpen from '@/components/icons/IconPen.vue'
import icontasks from '@/components/icons/IconTasks.vue'
import icontour from '@/components/icons/IconTour.vue'
import iconpanorama from '@/components/icons/IconPanorama.vue'

export default {
  name: 'IconBase',

  components: {
    iconvideo,
    icongallery,
    iconpost,
    iconlinkout,
    iconprospectus,
    iconmappin,
    iconpen,
    icontasks,
    icontour,
    iconpanorama
  },

  props: {
    icon: {
      type: String,
      default: 'arrow'
    },
    size: {
      type: String,
      default: '22px'
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
